<template>
  <div>
    <div class="inline">
      <el-divider direction="vertical"></el-divider>
      <h3 class="Xjiao">{{ $t("menu.DianziDianGong") }}</h3>
    </div>

    <div class="fff">
      <el-row v-for="(item, index) in DianziDianGong" :key="index">
        <el-col :span="21">
          <span>{{ item.title }}</span>
        </el-col>
            <router-link  :to="{path:item.routePath,query:  {ti:index+1}}">
                <el-button size="mini" round >{{ $t("menu.particulars") }}</el-button>
            </router-link>
        <el-divider class="divider"></el-divider>
      </el-row>
    </div>
    <!-- </el-col> -->
  </div>
</template>

<style scoped>
.divider {
  background-color: #eeeeee;
}
.fff {
  background: #ffffff;
  padding: 0px 20px;
  margin-bottom: 20px;
}
/* 
.el-button--mini {
  color: #ffffff;
  font-size: 12px !important;
  width: 80px;
  height: 28px;
  background: #999999;
}
.el-button--mini:hover {
  background: #666666;
  border: 1px solid #666666;
  color: #ffffff;
}
.el-button:focus,
.el-button--mini:focus {
  background: #1d2088;
  border: 1px solid #1d2088;
  color: #ffffff;
} */


</style>
<script>
// import bus from "@/assets/js/eventBus.js";
export default {
  data() {
    return {
      DianziDianGong: [],
      // 塑料
      // SelectList:[],
      title: "",

    };
  },

  created: function () {
    if (this.$i18n.locale == "TC") {
      this.title = "TC";
    } else if (this.$i18n.locale == "EN") {
      this.title = "EN";
    } else if (this.$i18n.locale == "SC") {
      this.title = "SC";
    }
    this.getSelect();
  },

  methods: {
    async getSelect() {
// o型圈
     const { data: ressan } = await this.$http.get("/Business/GetCatalogue", {
        params: { category: "electronics", languageType: this.title },
      });

      if (ressan.code !== 200) return console.log("数据请求失败! ");

      this.DianziDianGong =ressan.data;
      console.log( this.DianziDianGong)
    },
    // 详情点击事件
    // BtnDetalis(name) {
    //       this.$router.push({path:name.routePath,query: {ti:name.title}});
    //   // link-router和这里得传参ti一样

    // },
  },
};
</script>
